.surface {
  border-radius: var(--r-md);
  border: 1px solid var(--c-border-subtle);
  color: var(--c-text-primary);
}

.padded { padding: var(--sp-4); }

.l-sunken {
  background: var(--c-surface-sunken);
  border-color: var(--c-border-subtle);
}

.l-base {
  background: var(--c-surface);
  box-shadow: var(--sh-1);
}

.l-raised {
  background: var(--c-surface-raised);
  border-color: var(--c-border);
  box-shadow: var(--sh-2);
}

/* Стекло для таббара и sticky-футера. Фоллбэк обязателен:
   без поддержки backdrop-filter полупрозрачный фон превращается в кашу. */
.l-glass {
  background: var(--c-surface-glass);
  border-color: var(--c-border-subtle);
}

@supports (backdrop-filter: blur(1px)) {
  .l-glass { backdrop-filter: blur(16px) saturate(140%); }
}

/* Золотая рамка: то, что относится к картам и раскладам. Не кликается. */
.sacred { border-color: var(--c-border-sacred); }
